import React from 'react';

import { RoundedRectIndicator } from '../../../components/indicators/RoundedRectIndicator';

interface AttestationEditIndicatorProps {
  isHovered: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const AttestationEditIndicator: React.FC<AttestationEditIndicatorProps> = ({
  isHovered,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <RoundedRectIndicator
      width={12}
      height={12}
      borderRadius="50%"
      bgcolor={isHovered ? 'info.main' : 'info.light'}
      borderColor="info.main"
      hoverBgcolor="info.main"
      hoverBorderColor="info.main"
      hoverScale={1.15}
      isHovered={isHovered}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};

